<template>
	<div class="list">
		<div class="list-tt">六亲详解</div>
		<div class="list-info">
			<div v-if="infoHtml" class="liuqin-box">
				<div class="liuqin">
					<h4>祖上</h4>
					<p>
						{{infoHtml.zushang.niantui}} ，{{infoHtml.zushang.jielun}}
					</p>
				</div>
				<div class="liuqin">
					<h4>父母</h4>
					<p>
						父：{{infoHtml.fumu.futui}}{{infoHtml.fumu.fulun}} 。<br>
						母：{{infoHtml.fumu.mutui}}{{infoHtml.fumu.mulun}} 。
					</p>
				</div>
				<div class="liuqin">
					<h4>兄弟</h4>
					<p>{{infoHtml.xiongdi.xingtui}} ，{{infoHtml.xiongdi.jielun}}</p>
				</div>
				<div class="liuqin">
					<h4>配偶</h4>
					<p>{{infoHtml.peiou.xingtui}} ，{{infoHtml.peiou.jielun}}</p>
				</div>
				<div class="liuqin">
					<h4>子女</h4>
					<p>{{infoHtml.zinv.xingtui}} ，{{infoHtml.zinv.jielun}}</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['liuqin'],
		data() {
			return {
				infoHtml: '',
				sex: {
					1: '男',
					2: '女'
				},
				times: ['子时（23-01点）', '丑时（01-03点）', '寅时（03-05点）', '卯时（05-07点）', '辰时（07-09点）', '巳时（09-11点）',
					'午时（11-13点）', '未时（13-15点）', '申时（15-17点）', '酉时（17-19点）', '戌时（19-21点）', '亥时（21-23点）'
				],
				PALACE: {
					年: 0,
					月: 1,
					日: 2,
					时: 3
				},
				STAR: {
					母: ["正印", "偏印"],
					父: ["偏财"],
					妻: ["正财", "偏财"],
					夫: ["正官", "七杀"],
					兄弟: ["比肩", "劫财"],
					子女男: ["正官", "七杀"],
					子女女: ["食神", "伤官"]
				}
			}
		},
		methods: {
			getBazi() {
				var bazi = '';
				let type = this.liuqin.type;
				let sex = this.liuqin.sex;
				let year = this.liuqin.year;
				let month = this.liuqin.month;
				let day = this.liuqin.day;
				let chen = [23, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22];
				let time = chen[this.liuqin.time];
				let timeName = this.times[this.liuqin.time];

				if (type == 2) { //农历
					let lunar = Lunar.fromYmdHms(year, month, day, time, 0, 0);
					bazi = lunar.getEightChar();
				} else {
					let solar = Solar.fromYmdHms(year, month, day, time, 0, 0);
					let lunar = solar.getLunar();
					bazi = lunar.getEightChar();
				}

				let riGan = bazi.getDayGan();
				let gender = this.sex[sex];
				let tianGan = [bazi.getYearShiShenGan(), bazi.getMonthShiShenGan(), '比肩', bazi.getTimeShiShenGan()];
				let cangGan = [...bazi.getYearShiShenZhi(), ...bazi.getMonthShiShenZhi(), ...bazi.getDayShiShenZhi(), ...bazi.getTimeShiShenZhi()];
				this.infoHtml = this.getLiuQinDetail(riGan, gender, tianGan, cangGan);
				//console.log(json)
			},
			getLiuQinDetail(riGan, gender, tianGan, cangGan) {
				const result = {};

				// ------------------------------
				// 父母
				// ------------------------------
				{
					const 母 = this.hasStar(this.STAR.母, this.PALACE.月, tianGan, cangGan);
					const 母在年 = this.hasStar(this.STAR.母, this.PALACE.年, tianGan, cangGan);
					const 父 = this.hasStar(this.STAR.父, this.PALACE.月, tianGan, cangGan);
					const 父全局 = this.globalHas(this.STAR.父, tianGan, cangGan);

					let 母过程 = "";
					if (母.透干) 母过程 = "印星透月柱父母宫，母缘深";
					else if (母.藏干) 母过程 = "印星藏月支父母宫，母缘稳";
					else if (母在年.有星) 母过程 = "印星在年柱，母亲早年操劳";
					else 母过程 = "印星不现，母缘偏浅";

					let 父过程 = "";
					if (父.透干) 父过程 = "偏财透月柱父母宫，父缘深";
					else if (父.藏干) 父过程 = "偏财藏月支父母宫，父缘稳";
					else if (父全局) 父过程 = "父星不在父母宫，一生奔波";
					else 父过程 = "父星不现，父缘淡薄";

					result.fumu = {
						mutui: 母过程,
						futui: 父过程,
						mulun: 母.有星 ? "母亲贤良顾家，助力大" : "母缘一般，助力少",
						fulun: 父.有星 ? "父亲顾家能干，是家庭支柱" : "父亲缘薄，多靠自己"
					};
				}

				// ------------------------------
				// 兄弟
				// ------------------------------
				{
					const 手足 = this.hasStar(this.STAR.兄弟, this.PALACE.月, tianGan, cangGan);
					const 全局 = this.globalHas(this.STAR.兄弟, tianGan, cangGan);

					let 过程 = "";
					if (手足.透干) 过程 = "比劫透月柱，手足星明显";
					else if (手足.藏干) 过程 = "比劫藏月柱，有兄弟姐妹";
					else if (全局) 过程 = "比劫不居月令，手足缘一般";
					else 过程 = "无比劫星，手足缘弱";

					let 结论 = "";
					if (手足.有星) {
						结论 = gender === "男" ? "有兄弟姐妹，能互助亦有竞争" : "有姐妹或朋友帮扶";
					} else {
						结论 = "孤单命格，少手足助力";
					}

					result.xiongdi = {
						xingtui: 过程,
						jielun: 结论
					};
				}

				// ------------------------------
				// 配偶
				// ------------------------------
				{
					const 星组 = gender === "男" ? this.STAR.妻 : this.STAR.夫;
					const 配偶宫 = this.hasStar(星组, this.PALACE.日, tianGan, cangGan);
					const 名称 = gender === "男" ? "财星" : "官星";
					const 全局 = this.globalHas(星组, tianGan, cangGan);

					let 过程 = "";
					if (配偶宫.透干) 过程 = `${名称}透日柱夫妻宫，星宫相配`;
					else if (配偶宫.藏干) 过程 = `${名称}藏日支夫妻宫，缘分稳定`;
					else if (全局) 过程 = `${名称}全局有但不入夫妻宫，感情多波折`;
					else 过程 = `${名称}不入夫妻宫，感情多波折`;

					let 结论 = "";
					if (配偶宫.有星) {
						结论 = gender === "男" ? "妻子能干、顾家旺夫" : "丈夫稳重、有担当";
					} else {
						结论 = gender === "男" ? "妻缘一般，宜晚婚" : "夫缘偏弱，多靠自己";
					}

					result.peiou = {
						xingtui: 过程,
						jielun: 结论
					};
				}

				// ------------------------------
				// 子女
				// ------------------------------
				{
					const 星组 = gender === "男" ? this.STAR.子女男 : this.STAR.子女女;
					const 子女宫 = this.hasStar(星组, this.PALACE.时, tianGan, cangGan);
					const 全局 = this.globalHas(星组, tianGan, cangGan);

					let 过程 = "";
					if (子女宫.透干) 过程 = "子女星透时柱子女宫，子女缘强";
					else if (子女宫.藏干) 过程 = "子女星藏时支，有子女缘分";
					else if (全局) 过程 = "子女星全局有但不入子女宫，子女缘不稳";
					else 过程 = "子女星弱，子女缘薄或得子晚";

					let 结论 = 子女宫.有星 ?
						"子女聪明孝顺，晚年有依靠" :
						"子女少，幼时费心，晚年靠自己";

					result.zinv = {
						xingtui: 过程,
						jielun: 结论
					};
				}

				// ------------------------------
				// 祖上
				// ------------------------------
				{
					const 年印 = this.hasStar(this.STAR.母, this.PALACE.年, tianGan, cangGan).有星;
					const 年财 = this.hasStar(this.STAR.父, this.PALACE.年, tianGan, cangGan).有星;

					let 过程 = "";
					if (年印 && 年财) 过程 = "年柱财印两见，祖上家境中等，有文化";
					else if (年印) 过程 = "年柱见印，祖上书香门第，家教严";
					else 过程 = "年柱无财印，祖上普通，无祖业";

					result.zushang = {
						niantui: 过程,
						jielun: 年印 ? "祖上有德，可得长辈庇佑" : "祖上平常，自力更生"
					};
				}

				return result;
			},
			safeArray(arr) {
				if (!arr) return [];
				if (typeof arr === 'string') return [arr];
				if (Array.isArray(arr)) return arr;
				return [];
			},
			// 判断星是否在宫位里
			hasStar(starList, palaceIdx, tianGan, cangGan) {
				const tg = tianGan[palaceIdx] || '';
				const dz = this.safeArray(cangGan[palaceIdx]);

				const 透干 = starList.includes(tg);
				const 藏干 = dz.some(s => starList.includes(s));

				return {
					透干,
					藏干,
					有星: 透干 || 藏干
				};
			},
			// 判断全局是否有星
			globalHas(starList, tianGan, cangGan) {
				for (let s of tianGan) {
					if (starList.includes(s)) return true;
				}
				for (let arr of cangGan) {
					let a = this.safeArray(arr);
					if (a.some(s => starList.includes(s))) return true;
				}
				return false;
			},

		},
		watch: {
			liuqin(newVal, oldVal) {
				this.getBazi()
			}
		},
	}
</script>

<style scoped="scoped">
	.liuqin-box{
		width: 100%;
	}
	.liuqin {
		background-color: #f3f5f7;
		border-radius: 10px;
		margin-top: 10px;
		padding: 20px;
	}

	.liuqin h4 {
		font-weight: normal;
		font-size: 17px;
		line-height: 30px;
		padding-bottom: 5px;
	}

	.liuqin p {
		color: #666;
		line-height: 30px;
		text-align: justify;
	}
</style>



// WEBPACK FOOTER //
// src/page/liuqin.vue